export const INITIAL_STATE = {
    title: "",
    desc: "",
    price: 0,
    category: "",
    tags: [],
    images: {
        sm: "",
        md: "",
        lg: "",
    },
    quantity: 0,
};

export const formReducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_INPUT":
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case "CHANGE_TAGS":
            return {
                ...state,
                tags: [...state.tags, action.payload],
            };
        case "REMOVE_TAG":
            return {
                ...state,
                tags: state.tags.filter((t) => t !== action.payload),
            };
        case "INCREASE":
            return {
                ...state,
                quantity: state.quantity + 1,
            };
        case "DECREASE":
            return {
                ...state,
                quantity: state.quantity - 1,
            };
        default:
            return state;

    }
}